import { StyleSheet } from '@react-pdf/renderer'
import { PDF_COLORS } from 'features/reporting/pdfGeneration/constants/colors'
import { PDF_LAYOUT } from 'features/reporting/pdfGeneration/constants/layout'
import { PDF_TYPOGRAPHY } from 'features/reporting/pdfGeneration/constants/typography'

export const workPackPdfStyles = StyleSheet.create({
  page: { paddingBottom: PDF_LAYOUT.SPACING.XXXLARGE * 2 },
  content: { marginBottom: 0 },
  coverTitle: {
    fontSize: 24,
    fontFamily: 'Helvetica-Bold',
    marginTop: 32,
    marginBottom: 20,
  },
  tocRow: { flexDirection: 'row', marginBottom: 10 },
  tocLabel: {
    flexGrow: 1,
    flexShrink: 1,
    fontSize: 11,
    color: PDF_COLORS.PRIMARY,
    textDecoration: 'none',
  },
  tocNumber: { width: 35, textAlign: 'right', fontSize: 11 },
  title: { fontSize: 16, fontFamily: 'Helvetica-Bold', marginBottom: 10 },
  heading: {
    fontSize: PDF_TYPOGRAPHY.FONT_SIZE.MEDIUM,
    fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.BOLD,
    color: PDF_COLORS.PRIMARY,
    marginBottom: PDF_LAYOUT.SPACING.SMALL,
  },
  sectionHeading: { marginTop: PDF_LAYOUT.SPACING.LARGE },
  note: { fontSize: 9, color: PDF_COLORS.TEXT_SECONDARY, marginBottom: 12 },
  image: { width: '100%', height: 300, objectFit: 'contain', marginBottom: 10 },
  legendRow: { fontSize: 10, lineHeight: 1.2, marginBottom: 4 },
})
